import React, { Component, Fragment } from 'react'

async function getFacebookPages() {
  return new Promise((resolve, reject) => {
    window.miBaby.fbCheck(
      function(loggedIn) {
        if (loggedIn) {
          window.FB.api('/me', {}, function(uResponse) {
            window.FB.api('/me/accounts', {}, function(response) {
              if (response && response.data) {
                response.data.unshift({
                  name: 'Eigenes Profil (' + uResponse.name + ')',
                  id: uResponse.id,
                })

                resolve(response.data)
              }
            })
          })
        } else {
          reject(new Error('Abrufen fehlgeschlagen.'))
        }
      },
      { scope: 'pages_show_list' },
      true,
      true
    )
  })
}

const SelectView = ({ loggedIn, logIn, pages, selectedPageId, select }) =>
  loggedIn ? (
    <Fragment>
      <p>Wähle ein Facebook-Profil aus</p>
      <ul className="gutter-top list-group">
        {pages.map(({ id, name }) => {
          const isSelected = id === selectedPageId
          return (
            <li
              key={id}
              onClick={() => select(id)}
              style={{ cursor: 'pointer' }}
              className={`list-group-item ${isSelected ? 'active' : ''}`}
            >
              <i
                className="glyphicon glyphicon-ok"
                style={{
                  opacity: isSelected ? 1 : 0.2,
                  color: isSelected ? 'white' : undefined,
                }}
              />{' '}
              {name}
            </li>
          )
        })}
      </ul>
    </Fragment>
  ) : (
    <button className="btn btn-fb" onClick={logIn}>
      Facebook-Profil auswählen
    </button>
  )

export default class FacebookPageSelect extends Component {
  state = {
    loggedIn: false,
    loading: false,
    selectedPageId: null,
    error: null,
  }

  onLogIn = async () => {
    this.setState({ loading: true })
    try {
      const pages = await getFacebookPages()
      this.setState({
        loading: false,
        pages,
        loggedIn: true,
      })
    } catch (e) {
      this.setState({
        error: e,
      })
    }
  }

  select = selectedPageId => {
    this.setState({ selectedPageId }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.selectedPageId)
      }
    })
  }

  render() {
    const { loggedIn, pages, selectedPageId, loading, error } = this.state
    return loading ? (
      <img src="/img/lightbox_loading.gif" />
    ) : (
      <Fragment>
        {error && (
          <div className="panel panel-error">
            <div className="panel-body">{error}</div>
          </div>
        )}
        <SelectView
          {...{
            loggedIn,
            pages,
            selectedPageId,
            logIn: this.onLogIn,
            select: this.select,
          }}
        />
      </Fragment>
    )
  }
}

export const FacebookPageSelectWidget = ({ value, onChange }) => (
  <FacebookPageSelect value={value} onChange={onChange} />
)
